:host {
  display: block;
  box-sizing: border-box;
  border-top: 1px solid var(--color-surface03);
  border-bottom: 1px solid var(--color-surface03);
}

:host([sticky]) {
  position: sticky;
  z-index: 1;
  bottom: 0;
  background-color: var(--color-surface01);
}
